import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useRailbar } from "@circle-react/hooks/chatsV2/useRailbar";
import type { PropsWithChildren } from "react";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

interface HeaderProps {
  className?: string;
  hasNoBorder?: boolean;
}
export const Header = ({
  hasNoBorder,
  children,
  className = "",
}: PropsWithChildren<HeaderProps>) => {
  const { isCircleV4 } = useCircleV4();
  const { isChatSpace, isCourseSpace } = useRailbar();

  let minHeightStyles = "min-h-[56px]";

  if (hasNoBorder) {
    minHeightStyles = "min-h-[48px]";
  } else if (!isCircleV4 && (isChatSpace || isCourseSpace)) {
    minHeightStyles = "min-h-[72px]";
  }

  return (
    <div
      className={classNames(
        "text-darkest flex items-center font-medium",
        isCircleV4 ? "px-5" : "px-6",
        minHeightStyles,
        {
          "!h-14": isCircleV4,
          "border-primary dark:border-secondary border-b py-3": !hasNoBorder,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
